import { createContext, useContext, useMemo } from "react";

const Ctx = createContext({ month: null });

/** Tells every empty card inside it WHICH month the user is looking at, so the
 *  card can state the real reason it holds no data instead of "no data". */
export const DataScope = ({ month, children }) => {
    const value = useMemo(() => ({ month: month || null }), [month]);
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useDataScope = () => useContext(Ctx);

/** "2026-08-25" | "2026-08" -> "2026-08" */
export const monthOf = (iso) =>
    typeof iso === "string" && iso.length >= 7 ? iso.slice(0, 7) : null;
